function ArrowLeftAlt({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M10.1539 6.34616L11.2077 7.43076L7.38845 11.25L19.5 11.25L19.5 12.75L7.38845 12.75L11.2077 16.5692L10.1539 17.6538L4.50005 12L10.1539 6.34616Z"
        fill="#212121"
      />
    </svg>
  );
}

export default ArrowLeftAlt;
